import { DesignTokens } from '@insided/design-tokens'
import { ComponentChildren, FunctionalComponent } from 'preact'

export interface FieldContainerProps {
  inputId: string
  title: string
  children: ComponentChildren
}

const FieldContainer: FunctionalComponent<FieldContainerProps> = ({ inputId, title, children }) => {
  return (
    <div style={{ marginBottom: DesignTokens.SpacingEnum.S16 }}>
      <label for={inputId} style={{ marginBottom: DesignTokens.SpacingEnum.S4 }}>
        {title}
      </label>
      {children}
    </div>
  )
}

export default FieldContainer
